import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntitySimulation } from "../../entity/EntitySimulation";

export class DtoSimulationsGetRes extends EntitySimulation {
  public items: EntitySimulation[]  = [];
}
